import FirestoreDocument from "../../../types/FirestoreDocument";
import FirestoreLifecycle from "../../../types/FirestoreLifecycle";
import { any, boolean, enumValues, nullable, number, string } from "../../../types/_types";

import importSources from "../constants/importSources";
import importStatuses from "../constants/importStatuses";

export const Import = FirestoreDocument.extend({
	source: enumValues(importSources),
	status: enumValues(importStatuses).default(importStatuses.PENDING),
	error: nullable(string()),
	title: string().default(""),
	data: any(),
	subject: FirestoreDocument,
	skipCover: boolean(),
	forceCover: boolean(),
	disableDeliveryNeeded: boolean(),
	// Runs of the current data that died without finishing; new data starts the count over
	requeues: number().default(0),
}).merge(FirestoreLifecycle);
